export const ListName = [
    {name: 'Tất cả', value: ''},
    {value: 'received_1d', name: 'Đã nhận sau 1 ngày'},
    {value: 'received_2d', name: 'Đã nhận sau 2 ngày'},
    {value: 'received_3d', name: 'Đã nhận sau 3 ngày'},
    {value: 'received_4d', name: 'Đã nhận sau >=4 ngày'},
    {value: 'not_received', name: 'Chưa nhận may'},
    {name: 'Quá hạn', value: 'y'},
    {name: 'Quá hạn (đã sản xuất)', value: 'yy'},
    {name: 'Quá hạn (chưa & đang sản xuất)', value: 'yn'},
    {name: 'Không quá hạn', value: 'n'},
    {value: '1', name: 'Bình thường'},
    {value: '2', name: 'Cao'},
    {value: '3', name: 'Cao nhất'}
]
